import { Box, Button, Flex, Icon, Image, Stack, useBreakpointValue } from "@chakra-ui/react";
import { ArrowLeftIcon } from "@phosphor-icons/react/dist/ssr";

import { isPortrait } from "@/utilities/useOrientation";

const Header = ({ developmentData, step, setStep }) => {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const orientation = isPortrait() ? "portrait" : "landscape";

    return (
        <Box
            w="100vw"
            minH={{ base: "8vh", md: "10vh" }}
            alignContent="center"
            borderBottom="1px solid #fff"
            zIndex={999}
            position="fixed"
            background={
                step != 1
                    ? developmentData?.branding_props?.selection_props?.header_styles?.background
                    : developmentData?.branding_props?.init_props?.header_styles?.background ||
                      "transparent"
            }
        >
            <Flex
                alignContent="center"
                justifyContent={{
                    base: "space-between",
                    md: step != 1 ? "space-between" : "center",
                }}
                gap={4}
                alignItems="center"
                mx="2vw"
            >
                {step != 1 && isGreaterThanMd && orientation === "landscape" && (
                    <Stack>
                        <Button
                            bg="#EDEDED"
                            rounded="full"
                            w={{ base: "2vh", lg: "4.5vh" }}
                            h={{ base: "2vh", lg: "4.5vh" }}
                            boxShadow="md"
                            onClick={() => setStep(step - 1)}
                        >
                            <Icon color="black" fontSize={{ base: "4vw", lg: "2vh" }}>
                                <ArrowLeftIcon weight="bold" />
                            </Icon>
                        </Button>
                    </Stack>
                )}
                <Stack>
                    <Image
                        src={
                            step == 1
                                ? developmentData?.branding_props?.logo_header_master ||
                                  developmentData?.branding_props?.logo
                                : developmentData?.branding_props?.logo_header_selection ||
                                  developmentData?.branding_props?.logo_header_master ||
                                  developmentData?.branding_props?.logo
                        }
                        maxW={{
                            base: "35vw",
                            md: isGreaterThanMd && orientation === "landscape" ? "10vw" : "25vw",
                        }}
                        minH={{ base: "40px", md: "3.5vh" }}
                        maxH={{
                            base: "5vh",
                            md: isGreaterThanMd && orientation === "landscape" ? "6vh" : "8vh",
                        }}
                        objectFit="contain"
                    />
                </Stack>
                {step != 1 &&
                    (!isGreaterThanMd || (isGreaterThanMd && orientation === "portrait")) && (
                        <Stack>
                            <Button
                                bg="#EDEDED"
                                rounded="full"
                                w={{ base: "4vh", lg: "4.9vh" }}
                                h={{ base: "4vh", lg: "4.9vh" }}
                                boxShadow="md"
                                onClick={() => setStep(1)}
                            >
                                <Icon
                                    color="black"
                                    boxSize={{
                                        base: "3.5vw",
                                        lg:
                                            isGreaterThanMd && orientation === "landscape"
                                                ? "2vh"
                                                : "3vh",
                                    }}
                                >
                                    <ArrowLeftIcon />
                                </Icon>
                            </Button>
                        </Stack>
                    )}
                {step != 1 && isGreaterThanMd && orientation === "landscape" && <Stack></Stack>}
            </Flex>
        </Box>
    );
};

export default Header;
